import Typography from '@ui/Typography'
import { HStack, VStack } from '@ui/layout/Stack'

import * as styles from './CallQualityFeedbackHeader.css'

type CallQualityFeedbackHeaderProps = {
  title?: React.ReactNode
  subtitle?: React.ReactNode
}

export default function CallQualityFeedbackHeader({
  title,
  subtitle,
}: CallQualityFeedbackHeaderProps) {
  return (
    <HStack alignItems="center" className={styles.root}>
      <VStack>
        {title ? (
          <Typography color="textPrimary" variant="caption1">
            {title}
          </Typography>
        ) : null}
        {subtitle ? (
          <Typography color="textSecondary" variant="caption1">
            {subtitle}
          </Typography>
        ) : null}
      </VStack>
    </HStack>
  )
}
